export default {
  ACTIVATE_ACCOUNT: {
    TITLE: 'Activating account',
    SUBTITLE:
      'Please wait while we activate your account. This may take a few minutes',
    SUCCESS_MESSAGE:
      'Your account has been activated, redirecting to login page.',
    ERROR_MESSAGE:
      'Failed to activate your account, please contact our support.'
  }
}
